import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _isNil from "lodash/isNil";
import { unstable_createAnimationStyles as createAnimationStyles } from '@fluentui/react-bindings';
import { pxToRem } from '../../../../utils';
import Loader from '../../../../components/Loader/Loader';
import getBorderFocusStyles from '../../getBorderFocusStyles';
import getIconFillOrOutlineStyles from '../../getIconFillOrOutlineStyles';
var buttonStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables,
        theme = _ref.theme;
    var siteVariables = theme.siteVariables;
    var borderWidth = siteVariables.borderWidth;
    var borderFocusStyles = getBorderFocusStyles(Object.assign({
      siteVariables: siteVariables,
      borderPadding: borderWidth
    }, p.circular && {
      borderPadding: pxToRem(4)
    }));
    return Object.assign({
      height: v.height,
      minWidth: _isNil(p.loading) ? v.minWidth : v.loadingMinWidth,
      maxWidth: v.maxWidth,
      color: v.color,
      backgroundColor: v.backgroundColor,
      borderRadius: v.borderRadius,
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      padding: v.padding,
      verticalAlign: 'middle',
      cursor: 'pointer'
    }, p.size === 'small' && {
      padding: v.sizeSmallPadding,
      height: v.sizeSmallHeight,
      minWidth: v.sizeSmallMinWidth
    }, {}, !p.text && Object.assign({
      outline: 0,
      borderWidth: borderWidth,
      borderStyle: 'solid',
      borderColor: v.borderColor,
      boxShadow: v.boxShadow,
      ':hover': {
        color: v.colorHover,
        backgroundColor: v.backgroundColorHover,
        borderColor: v.borderColorHover
      },
      ':active': Object.assign({}, createAnimationStyles('scaleDownSoft', theme), {
        color: v.colorActive,
        backgroundColor: v.backgroundColorActive,
        borderColor: v.borderColorActive,
        boxShadow: 'none'
      }),
      ':focus': Object.assign({}, borderFocusStyles[':focus']),
      ':focus-visible': Object.assign({}, borderFocusStyles[':focus-visible'], {
        borderColor: v.borderColor,
        borderWidth: borderWidth,
        ':hover': {
          borderColor: v.borderColorHover
        }
      })
    }, p.size === 'small' && {
      boxShadow: 'none'
    }), {}, p.circular && !p.text && Object.assign({
      minWidth: v.height,
      padding: 0,
      borderRadius: v.circularBorderRadius
    }, p.size === 'small' && {
      minWidth: v.sizeSmallHeight
    }), {}, p.text && Object.assign({
      color: v.textColor,
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      padding: "0 ".concat(pxToRem(8))
    }, getIconFillOrOutlineStyles({
      outline: true
    }), {
      ':hover': Object.assign({
        color: v.textColorHover
      }, getIconFillOrOutlineStyles({
        outline: false
      })),
      ':focus': Object.assign({
        boxShadow: 'none'
      }, borderFocusStyles[':focus']),
      ':focus-visible': Object.assign({}, borderFocusStyles[':focus-visible'])
    }, p.primary && {
      color: v.textPrimaryColor
    }), {}, p.primary && !p.text && {
      color: v.primaryColor,
      backgroundColor: v.primaryBackgroundColor,
      borderColor: v.primaryBorderColor,
      boxShadow: v.primaryBoxShadow,
      ':active': Object.assign({}, createAnimationStyles('scaleDownSoft', theme), {
        backgroundColor: v.primaryBackgroundColorActive,
        boxShadow: 'none'
      }),
      ':focus': Object.assign({}, borderFocusStyles[':focus']),
      ':focus-visible': Object.assign({}, borderFocusStyles[':focus-visible']),
      ':hover': {
        color: v.primaryColorHover,
        backgroundColor: v.primaryBackgroundColorHover
      }
    }, {}, p.inverted && {
      backgroundColor: siteVariables.colorScheme.silver.background,
      borderColor: siteVariables.colorScheme.silver.border,
      color: siteVariables.colorScheme.silver.foreground,
      ':active': Object.assign({}, createAnimationStyles('scaleDownSoft', theme), {
        backgroundColor: siteVariables.colorScheme.silver.backgroundPressed,
        color: siteVariables.colorScheme.silver.foregroundHover
      }),
      ':hover': {
        backgroundColor: siteVariables.colorScheme.silver.backgroundHover,
        color: siteVariables.colorScheme.silver.foregroundHover
      },
      ':focus': Object.assign({}, borderFocusStyles[':focus'], {
        boxShadow: 'none'
      }),
      ':focus-visible': Object.assign({}, borderFocusStyles[':focus-visible'], {
        backgroundColor: siteVariables.colorScheme.silver.backgroundPressed,
        color: siteVariables.colorScheme.silver.foregroundHover
      })
    }, {}, p.disabled && Object.assign({
      cursor: 'default',
      color: v.colorDisabled,
      boxShadow: 'none',
      pointerEvents: 'none',
      ':hover': {
        color: v.colorDisabled
      }
    }, p.text && {
      color: v.textColorDisabled,
      backgroundColor: 'transparent',
      ':hover': {
        color: v.textColorDisabled
      }
    }, {}, !p.text && {
      backgroundColor: v.backgroundColorDisabled,
      borderColor: v.borderColorDisabled
    }), {}, p.fluid && {
      width: '100%',
      maxWidth: '100%'
    }, {}, p.iconOnly && Object.assign({
      minWidth: v.height,
      padding: 0,
      ':hover': Object.assign({}, getIconFillOrOutlineStyles({
        outline: false
      }), {
        color: v.textColorIconOnlyHover,
        background: v.backgroundColorIconOnlyHover
      })
    }, p.size === 'small' && {
      minWidth: v.sizeSmallHeight
    }));
  },
  // modifies the text of the button
  content: function content(_ref2) {
    var p = _ref2.props,
        v = _ref2.variables;
    return Object.assign({
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: v.contentFontSize,
      fontWeight: v.contentFontWeight,
      lineHeight: v.contentLineHeight
    }, p.size === 'small' && {
      fontSize: v.sizeSmallContentFontSize,
      lineHeight: v.sizeSmallContentLineHeight
    });
  },
  icon: function icon(_ref3) {
    var p = _ref3.props;
    return Object.assign({}, p.loading && {
      margin: 0,
      opacity: 0,
      width: 0
    });
  },
  loader: function loader(_ref4) {
    var _Object$assign;

    var p = _ref4.props,
        v = _ref4.variables;
    return Object.assign((_Object$assign = {}, _defineProperty(_Object$assign, "& .".concat(Loader.slotClassNames.indicator), {
      width: p.size === 'small' ? v.sizeSmallLoaderSize : v.loaderSize,
      height: p.size === 'small' ? v.sizeSmallLoaderSize : v.loaderSize
    }), _defineProperty(_Object$assign, "& .".concat(Loader.slotClassNames.svg), {
      ':before': {
        animationName: {
          to: {
            transform: "translate3d(0, ".concat(p.size === 'small' ? v.sizeSmallLoaderSvgAnimationHeight : v.loaderSvgAnimationHeight, ", 0)")
          }
        },
        borderWidth: p.size === 'small' ? v.sizeSmallLoaderBorderSize : v.loaderBorderSize,
        width: p.size === 'small' ? v.sizeSmallLoaderSize : v.loaderSize,
        height: p.size === 'small' ? v.sizeSmallLoaderSvgHeight : v.loaderSvgHeight
      }
    }), _Object$assign), p.hasContent && {
      marginRight: pxToRem(4)
    });
  }
};
export default buttonStyles;